import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import '../assets/styles/Footer.scss';

function Footer() {
  return (
    <footer>
      <div className="footer_contact">
        <a href="mailto:hollemaertdylan@gmail.com">
          <EmailIcon fontSize="small"/> hollemaertdylan@gmail.com
        </a>
        <a href="tel:+33636091645">
          <PhoneIcon fontSize="small"/> +33 6 36 09 16 45
        </a>
      </div>

      <div className="footer_social">
        <a href="https://github.com/dark-dylan-dev/" target="_blank" rel="noreferrer"><GitHubIcon/></a>
        <a href="https://www.linkedin.com/in/dylan-hollemaert/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
      </div>

      <p className="footer_copy">
        &copy; 2026 Dylan Hollemaert &nbsp;·&nbsp; Template by{" "}
        <a href="https://github.com/yujisatojr/react-portfolio-template/" target="_blank" rel="noreferrer">
          Yuji Sato
        </a>
      </p>
    </footer>
  );
}

export default Footer;